import React, { useState } from "react";
import PropTypes from "prop-types";
import PriceCard from "../price-card";

import styles from "./styles.m.css";

const RateCard = ({ title, className = "", price = "", oldPrice = "" }) => {
  if (!title) {
    return null;
  }

  const [Amount, setAmount] = useState([]);

  function handleChange(e) {
    setAmount(parseFloat(e.target.value) * parseFloat(price));
  }

  return (
    <div className={`${styles.title} ${className}`}>
      <h3 className={styles.text}>{title}</h3>
      <PriceCard price={price} />
      <div className={styles["check-price-rate"]}>
        <div className={styles["gram"]}>
          <label>Gram</label>
          <input type="number" onChange={handleChange.bind(this)} />
        </div>
        <div className={styles["amount"]}>
          <label>Amount</label>
          <input type="number" readOnly value={Amount} />
        </div>
      </div>
    </div>
  );
};

RateCard.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  price: PropTypes.string,
  oldPrice: PropTypes.string
};

export default RateCard;
